import React from "react";
import { FramingPreview } from "./FramingPreview";
import { FRAMING_FINISHES, framingRetail } from "../lib/framing";

export const StandardFramingConfigurator = ({ imageSrc, options, onChange, settings, testPrefix = "standard-framing" }) => {
  const update = (idx, patch) => onChange(options.map((o, i) => (i === idx ? { ...o, ...patch } : o)));
  const enabledCount = options.filter((o) => o.enabled).length;

  return (
    <div className="border border-neutral-200 bg-white" data-testid={`${testPrefix}-section`}>
      <div className="px-4 py-3 border-b border-neutral-200">
        <div className="overline text-neutral-700">3. Enmarcación sencilla · formatos estándar</div>
        <p className="text-xs text-neutral-500 mt-1 leading-relaxed">
          Activa solo los formatos prefabricados que quieres ofrecer. La obra se reencuadra dentro de la proporción estándar; el original no cambia. Para formatos especiales o sin recorte, usaremos talleres de enmarcación.
        </p>
      </div>
      <div className="divide-y divide-neutral-100">
        {options.map((o, idx) => {
          const minRetail = Math.min(...FRAMING_FINISHES.map((f) => framingRetail(o, f.code, settings)));
          return (
            <div key={o.code} className={`p-4 grid md:grid-cols-12 gap-4 ${!o.quality_ok ? "opacity-60" : ""}`} data-testid={`${testPrefix}-${o.code}`}>
              <label className="md:col-span-1 flex items-start pt-1">
                <input
                  type="checkbox"
                  checked={!!o.enabled}
                  disabled={!o.quality_ok}
                  onChange={(e) => update(idx, { enabled: e.target.checked })}
                  className="w-4 h-4"
                  data-testid={`${testPrefix}-enable-${o.code}`}
                />
              </label>
              <div className="md:col-span-3">
                <FramingPreview src={imageSrc} option={o} />
              </div>
              <div className="md:col-span-8 space-y-3">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div>
                    <div className="font-serif text-xl">Marco {o.frame_label}</div>
                    <div className="text-xs text-neutral-500 mt-1">Impresión {o.print_label} cm · {o.quality_ok ? `${o.dpi} DPI` : `${o.dpi} DPI · baja calidad`}</div>
                  </div>
                  <div className="text-right">
                    <div className="overline text-[10px] text-neutral-500">PVP desde</div>
                    <div className="font-serif text-lg">€{minRetail.toFixed(2)}</div>
                  </div>
                </div>
                <div className="grid sm:grid-cols-3 gap-2 text-[11px] text-neutral-500">
                  {FRAMING_FINISHES.map((f) => (
                    <div key={f.code} className="border border-neutral-200 px-3 py-2">
                      <div className="overline text-[9px] text-neutral-400">{f.short}</div>
                      <div className="font-serif text-base text-neutral-900">€{framingRetail(o, f.code, settings).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
                <div className="grid sm:grid-cols-3 gap-3 items-end">
                  <label className="text-xs text-neutral-500">
                    Tu neto (€)
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={o.net_earnings}
                      disabled={!o.enabled}
                      onChange={(e) => update(idx, { net_earnings: e.target.value === "" ? "" : parseFloat(e.target.value) })}
                      className="mt-1 w-full border border-neutral-200 px-2 py-1.5 text-xs disabled:bg-neutral-50"
                      data-testid={`${testPrefix}-net-${o.code}`}
                    />
                  </label>
                  <label className="text-xs text-neutral-500">
                    Encuadre horizontal
                    <input type="range" min="0" max="1" step="0.01" value={o.crop_x ?? 0.5} disabled={!o.enabled} onChange={(e) => update(idx, { crop_x: parseFloat(e.target.value) })} className="mt-2 w-full" data-testid={`${testPrefix}-crop-x-${o.code}`} />
                  </label>
                  <label className="text-xs text-neutral-500">
                    Encuadre vertical
                    <input type="range" min="0" max="1" step="0.01" value={o.crop_y ?? 0.5} disabled={!o.enabled} onChange={(e) => update(idx, { crop_y: parseFloat(e.target.value) })} className="mt-2 w-full" data-testid={`${testPrefix}-crop-y-${o.code}`} />
                  </label>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="px-4 py-3 border-t border-neutral-200 bg-neutral-50 text-xs text-neutral-600">
        {enabledCount > 0 ? `${enabledCount} formato(s) de enmarcación sencilla activos.` : "No ofrecerás enmarcación sencilla; el comprador verá talleres para acabados especiales."}
      </div>
    </div>
  );
};

export default StandardFramingConfigurator;
